import { render } from "./TaxesDialog.vue?vue&type=template&id=01b60458&scoped=true"
import script from "./TaxesDialog.vue?vue&type=script&lang=js"
export * from "./TaxesDialog.vue?vue&type=script&lang=js"

import "./TaxesDialog.vue?vue&type=style&index=0&id=01b60458&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b60458"]])

export default __exports__